<div class="mb-27 mct-flex mct-row mct-justify-between mct-items-center"  >
  <span class="title-header">{{ 'committees.search.header' | translate | titlecase }}</span>
  <button
    *wlAccessControl="{ SecurityElement: securityElementNames.Committees_Module, MinimumAccessLevel: 2 }"
    
    class="mct-flex atlas-btn atlas-btn-primary mct-justify-center mct-items-center"
    type="button"
    (click)="addDialog.open()"
  >
    <i class="large-icon pi pi-plus"></i>
    <span>{{ 'committees.search.add-a-committee' | translate | uppercase }}</span>
  </button>
</div>

<div class="params-container mb-20">
  <div class="search-header mb-32">{{ 'committees.search.search-committees' | translate | titlecase }}</div>
  <wl-committee-search-params [(searchParams)]="searchParams"></wl-committee-search-params>
  <div class="mt-33 mct-flex mct-row mct-justify-end mct-items-center"  >
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="searchGrid.search()">
      {{ 'common.run-this-search' | translate | uppercase }}
    </button>
  </div>
</div>

<wl-committee-search-grid #searchGrid [(searchParams)]="searchParams"></wl-committee-search-grid>

<wl-committee-add-dialog #addDialog></wl-committee-add-dialog>
